import React from 'react';

const SideBar = ({...props}) => {
    return (
        <div className="bg-ea_gray_dark text-white flex-1 p-2 md:p-6 rounded-bl-lg">
            {props.children}
        </div>
    )
}

export default SideBar;
